import React from 'react'
import widgetService from 'live/services/widgets'
import { DrtReducer } from './DrtReducer'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import i18n from 'live/services/i18n'
import { Configs, DrtMessage, DrtState } from './types/index'

import { withSuspenseWrapper } from '../../../SuspenseWrapper'

const WrapperDrtWidget = withSuspenseWrapper(React.lazy(() => import('./DrtWidget')))
const WrapperManagementDrtWidget = withSuspenseWrapper(React.lazy(() => import('./ManagementDrtWidget')))

widgetService.register({
    type: 'Rig Performance Index (DRT)',
    get name() {
        return i18n('Detailed Report Table')
    },
    get description() {
        return i18n('KPI - Rig Performance Index (DRT)')
    },
    config: {
        color: 'red'
    },
    policies: {
        handleOwnMissingData: true
    },
    // the wrapper is needed to enable the reducer mechanism and comply the API
    impl: reactWidgetWrapper<DrtState, DrtMessage, Configs>(WrapperDrtWidget, DrtReducer)

})

widgetService.register({
    type: 'Management Rig Performance Index (DRT)',
    get name() {
        return i18n('Detailed Management Report Table')
    },
    get description() {
        return i18n('KPI - Management Rig Performance Index (DRT)')
    },
    config: {
        color: 'red'
    },
    policies: {
        handleOwnMissingData: true
    },
    // the wrapper is needed to enable the reducer mechanism and comply the API
    impl: reactWidgetWrapper<DrtState, DrtMessage, Configs>(WrapperManagementDrtWidget, DrtReducer)

})
